/**
 * @flow
 * @relayHash 007e433a31eb4d002eb396b1d3c4a71e
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteBatch} from 'relay-runtime';
export type footerRootQueryResponse = {|
  +viewer: ?{| |};
|};
*/


/*
query footerRootQuery(
  $hasUserId: Boolean!
  $userId: String!
) {
  viewer {
    ...Footer_viewer
    id
  }
}

fragment Footer_viewer on Viewer {
  user(userId: $userId) @include(if: $hasUserId) {
    serviceId
    ...CurrencySelector_user
    id
  }
  ...CurrencySelector_viewer
}

fragment CurrencySelector_user on User {
  id
  serviceId
  profile {
    currency
  }
}

fragment CurrencySelector_viewer on Viewer {
  currencies
}
*/

const batch /*: ConcreteBatch*/ = {
  "fragment": {
    "argumentDefinitions": [
      {
        "kind": "LocalArgument",
        "name": "hasUserId",
        "type": "Boolean!",
        "defaultValue": null
      },
      {
        "kind": "LocalArgument",
        "name": "userId",
        "type": "String!",
        "defaultValue": null
      }
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "footerRootQuery",
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "Footer_viewer",
            "args": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType"
  },
  "id": null,
  "kind": "Batch",
  "metadata": {},
  "name": "footerRootQuery",
  "query": {
    "argumentDefinitions": [
      {
        "kind": "LocalArgument",
        "name": "hasUserId",
        "type": "Boolean!",
        "defaultValue": null
      },
      {
        "kind": "LocalArgument",
        "name": "userId",
        "type": "String!",
        "defaultValue": null
      }
    ],
    "kind": "Root",
    "name": "footerRootQuery",
    "operation": "query",
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "currencies",
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "id",
            "storageKey": null
          },
          {
            "kind": "Condition",
            "passingValue": true,
            "condition": "hasUserId",
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "args": [
                  {
                    "kind": "Variable",
                    "name": "userId",
                    "variableName": "userId",
                    "type": "String!"
                  }
                ],
                "concreteType": "User",
                "name": "user",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "serviceId",
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "id",
                    "storageKey": null
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "args": null,
                    "concreteType": "Profile",
                    "name": "profile",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "currency",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ]
  },
  "text": "query footerRootQuery(\n  $hasUserId: Boolean!\n  $userId: String!\n) {\n  viewer {\n    ...Footer_viewer\n    id\n  }\n}\n\nfragment Footer_viewer on Viewer {\n  user(userId: $userId) @include(if: $hasUserId) {\n    serviceId\n    ...CurrencySelector_user\n    id\n  }\n  ...CurrencySelector_viewer\n}\n\nfragment CurrencySelector_user on User {\n  id\n  serviceId\n  profile {\n    currency\n  }\n}\n\nfragment CurrencySelector_viewer on Viewer {\n  currencies\n}\n"
};

module.exports = batch;



// WEBPACK FOOTER //
// ./src/queries/__generated__/footerRootQuery.graphql.js